"use client"

import { RotateCw } from "lucide-react"
import { cn } from "@/lib/utils"

interface FetchErrorProps {
  /** O que falhou, em minúsculas: "os cupons", "os produtos", "a leitura dos robôs" */
  what?: string
  onRetry: () => void
  /** Variante de linha única pra espaços apertados (ticker, footers) */
  compact?: boolean
  className?: string
}

/**
 * Estado de erro de leitura, distinto do empty state: vazio significa "não há
 * dados", isto significa "não consegui ler". Nunca renderizar mensagem
 * tranquilizadora quando a request falhou.
 */
export default function FetchError({ what = "os dados", onRetry, compact = false, className }: FetchErrorProps) {
  if (compact) {
    return (
      <div className={cn("flex items-center justify-between gap-3", className)}>
        <span className="text-xs text-rose-600 dark:text-rose-400">
          Não consegui atualizar {what} agora.
        </span>
        <button
          type="button"
          onClick={onRetry}
          className="tap-44 inline-flex flex-shrink-0 items-center gap-1.5 rounded-md border border-border/60 bg-background/60 px-2.5 py-1 text-[11px] font-medium text-foreground transition-colors hover:border-rose-500/40 hover:bg-muted/40"
        >
          <RotateCw className="h-3 w-3" aria-hidden="true" />
          Tentar de novo
        </button>
      </div>
    )
  }

  return (
    <div className={cn("flex h-full min-h-[160px] flex-col items-center justify-center gap-3 py-8 text-center", className)}>
      <p className="max-w-[300px] text-sm text-rose-600 dark:text-rose-400">
        Não consegui atualizar {what} agora. O painel está sem resposta do servidor — pode ser a conexão ou uma instabilidade passageira.
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="tap-44 inline-flex items-center gap-1.5 rounded-md border border-border/60 bg-background/60 px-3.5 py-2 text-xs font-medium text-foreground transition-colors hover:border-rose-500/40 hover:bg-muted/40"
      >
        <RotateCw className="h-3.5 w-3.5" aria-hidden="true" />
        Tentar de novo
      </button>
    </div>
  )
}
